import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-[#4A42A8] text-white hover:bg-[#6B63CC]",
        secondary: "border-transparent bg-[#EEEDFE] text-[#26215C] hover:bg-[#E2E0FB]",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "border-[#D8D4F8] bg-white text-[#26215C] hover:bg-[#F8F7FF]",
        success: "border-transparent bg-[#4A42A8]/12 text-[#4A42A8] hover:bg-[#4A42A8]/18",
        warning: "border-transparent bg-[#C4A45A]/16 text-[#26215C] hover:bg-[#C4A45A]/22",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
